import React, { useEffect, useState, useCallback } from "react";
import Input from "../../../../components/Common/Input/Input";
import DeleteIcon from "../../../../components/Common/SvgIcons/SocialIcons/DeleteIcon";
import {
  getAllAssignedQueriesActionHandler,
  deleteQueryActionHandler,
  putQueryActionHandler,
  putUnreadCountActionHandler,
  putIsReadActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/myQueriesActionHandler";
import { useOutletContext, useNavigate } from "react-router";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScrollComponent from "../../../../components/Common/InfiniteScroll/InfiniteScrollComponent";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import { myQueries } from "../../../../utils/mainTabs/admin/myQueries";
import classes from "./Course.module.scss";
import Button from "../../../../components/Common/Button/Button";
import profileImg from "../../../../assets/images/Common/profileImg.svg";
import {
  putQueryAction,
  getAllAssignedDataAction,
} from "../../../../store/actions/actionCreators/adminActionCreator/myQueryActionCreator";
import { createShotclasses } from "../../../../utils/mainTabs/manage/createShotclasses";
import { FormattedMessage } from "react-intl";
import Loader from "../../../../components/Common/Loader/Loader";

const Course = () => {
  const pageSize = 50;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const queryCourseData = useSelector((state) => state.myQueryReducer);
  const { queryData } = queryCourseData;

  const commonState = useSelector((state) => state.commonReducer);
  const { myProfile } = commonState;

  const [assignedData, setAssignedData] = useState([]);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [epoch, setEpoch] = useState(0);
  const [queryreplies, setQueryReplies] = useState([]);
  const [queryListActive, setQueryListActive] = useState(null);
  // const [idstore, setIdStore] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [commentPost, setCommentPost] = useState("");
  const [postUnreadCount, setpostUnreadCount] = useState();
  // const [firstTimeActive, setfirstTimeActive] = useState(false);
  const [lastQueryDataSupoort, setLastQueryDataSupport] = useState();
  const [loader, setLoader] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);

  const { tenantName } = useOutletContext();

  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  useEffect(() => {
    if (queryData?.length > 0) {
      // setLoader(false);
      setQueryReplies(queryData?.[0]);
      setQueryListActive(queryData?.[0]?.id);
    }
  }, [queryData?.length]); //queryData
  useEffect(() => {
    if (lastQueryDataSupoort === null) {
      setHasMoreData(false);
    }
    if (epoch >= 0) {
      dispatch(
        getAllAssignedQueriesActionHandler(
          "SHOTCLASS",
          epoch,
          epoch > 0 ? 10 : pageSize,
          setLastQueryDataSupport,
          setLoader
        )
      );
    }
  }, [dispatch, epoch, lastQueryDataSupoort]);

  const fetchMoreData = () => {
    setEpoch(
      queryData[queryData.length - 1].EpochValue
        ? queryData[queryData.length - 1].EpochValue
        : 0
    );
  };

  const convertTime = (isoTime) => {
    var hours = parseInt(isoTime.substring(0, 2), 10),
      minutes = isoTime.substring(3, 5),
      ampm = "AM";

    if (hours == 12) {
      ampm = "pm";
    } else if (hours == 0) {
      hours = 12;
    } else if (hours > 12) {
      hours -= 12;
      ampm = "PM";
    }

    return hours + ":" + minutes + " " + ampm;
  };
  const convertTimeAmPm = (isoTime) => {
    var hours = parseInt(isoTime.substring(0, 2), 10),
      ampm = "AM";

    if (hours == 12) {
      ampm = "pm";
    } else if (hours == 0) {
      hours = 12;
    } else if (hours > 12) {
      hours -= 12;
      ampm = "PM";
    }

    return ampm;
  };

  const queryListClick = (data) => {
    setQueryReplies(data);
    setQueryListActive(data?.id);
    if (data.IsReadByAdmin === false) {
      dispatch(putUnreadCountActionHandler(setpostUnreadCount));
      dispatch(putIsReadActionHandler(data?.id)).then((response) => {
        if (response.data) {
          const updatedData = queryData?.map((query) => {
            if (query?.id === data?.id) {
              return { ...query, IsReadByAdmin: response?.data };
            } else {
              return { ...query };
            }
          });
          dispatch(getAllAssignedDataAction(updatedData));
        }
      });
    }
  };
  const selectAllCheckbox = () => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(queryData?.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };
  const selectCheckbox = (data, e) => {
    // idstore.push(data.id);
    // const { id, checked } = e.target;
    // setIsCheck([...isCheck, id]);
    // if (!checked) {
    //   setIsCheck(isCheck.filter((item) => item !== id));
    // }
    const { id, checked } = e.target;
    let updatedIsCheck = [...isCheck];
    if (checked) {
      updatedIsCheck = [...isCheck, id];
    } else {
      updatedIsCheck = isCheck.filter((item) => item !== id);
    }
    setIsCheck(updatedIsCheck);
    setIsCheckAll(updatedIsCheck.length === queryData.length);
  };
  const deleteSelectedQuery = () => {
    setLoader(true);
    dispatch(deleteQueryActionHandler(isCheck)).then((response) => {
      if (response.data) {
        dispatch(
          getAllAssignedQueriesActionHandler(
            "SHOTCLASS",
            // epoch,
            // epoch > 0 ? 10 : pageSize,
            0,
            pageSize,
            setLastQueryDataSupport,
            setLoader,
            true
          )
        ).then((newQueryData) => {
          if (newQueryData?.data?.length > 0) {
            setQueryReplies(newQueryData?.data?.[0]);
            setQueryListActive(newQueryData?.data?.[0].id); // Set the first row as active
          } else {
            setQueryReplies([]);
            setQueryListActive(null);
          }
        });
        dispatch(setErrorHandler(errorTypes.SUCCESS, "Query has been deleted"));
        setIsCheck([]);
        setLoader(false);
      }
    });
  };
  const handleViewAttachemnt = (imgUrl) => {
    window.open(imgUrl, "_blank", "width=422, height=586").moveTo(800, 350);
  };
  const onSubmit = (data) => {
    setCommentPost(data.commentInput);
  };
  const handleComment = (e) => {
    setCommentPost(e.target.value);
  };
  const handleCommentBtn = () => {
    if (commentPost.trim()) {
      setBtnLoader(true);
      let data = {
        Category: {
          CategoryId: 1,
          CategoryName: "SHOTCLASS",
          CategoryType: "SHOTCLASS",
          DefaultAssignee: "",
        },
        CreatedBy: "",
        IsReadByAdmin: true,
        RelatedId: "",
        Replies: [
          {
            CreatedTime: `${queryreplies?.CreatedTime?.match(/\d\d:\d\d/)}`,
            Text: commentPost,
          },
        ],
        Text: "",
        id: queryreplies?.id,
      };
      // dispatch(putQueryActionHandler(data)).then((response) => {
      //   if (response) {
      //     const updatedData = queryData?.map((query) => {
      //       if (query?.id === response?.data?.id) {
      //         return { ...query, Replies: response?.data?.Replies };
      //       } else {
      //         return { ...query };
      //       }
      //     });
      //     setQueryReplies(response?.data);
      //     dispatch(putQueryAction(updatedData));
      //     setCommentPost("");
      //   }
      // });
      dispatchPutApi(data);
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && commentPost.trim()) {
      setBtnLoader(true);
      let data = {
        Category: {
          CategoryId: 1,
          CategoryName: "SHOTCLASS",
          CategoryType: "SHOTCLASS",
          DefaultAssignee: "",
        },
        CreatedBy: "",
        IsReadByAdmin: true,
        RelatedId: "",
        Replies: [
          {
            CreatedTime: `${queryreplies?.CreatedTime?.match(/\d\d:\d\d/)}`,
            Text: commentPost,
          },
        ],
        Text: "",
        id: queryreplies?.id,
      };
      dispatchPutApi(data);
    }
  };

  const dispatchPutApi = (data) => {
    dispatch(putQueryActionHandler(data)).then((response) => {
      if (response) {
        const updatedData = queryData?.map((query) => {
          if (query?.id === response?.data?.id) {
            return { ...query, Replies: response?.data?.Replies };
          } else {
            return { ...query };
          }
        });
        setQueryReplies(response?.data);
        dispatch(putQueryAction(updatedData));
        setCommentPost("");
        setBtnLoader(false);
      }
    });
  };
  return (
    // loader ? (
    //   <div className={classes.loader}>
    //     <Loader page />
    //   </div>
    // ) : (
    <div className={classes.courseMainBox}>
      {queryData?.length > 0 ? (
        <>
          <div className={classes.leftPanel}>
            <div className={classes.topHeader}>
              <h2>Course Queries</h2>
              {queryData?.length > 0 && (
                <div className={classes.checkboxSelectAll}>
                  <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <Input
                        label={<FormattedMessage id="SELECT_ALL" />}
                        type="checkbox"
                        name="selectAll"
                        width="2"
                        height="2"
                        labelColor="light"
                        direction="row-reverse"
                        checked={isCheckAll}
                        onClick={selectAllCheckbox}
                      />
                    </form>
                  </FormProvider>
                </div>
              )}
              {isCheck.length > 0 && (
                <span
                  className={classes.topHeader_DeleteIcon}
                  onClick={deleteSelectedQuery}
                  // style={{ "pointerEvents": "none" }}
                >
                  <DeleteIcon fill={"grey"} />
                  <FormattedMessage id="DELETE_TXT" />
                </span>
              )}
            </div>
            <div className={classes.courseQueriesContainer}>
              <InfiniteScrollComponent
                dataLength={queryData?.length}
                fetchMoreData={fetchMoreData}
                hasMoreData={hasMoreData}
                height={"58vh"}
              >
                {queryData?.map((query) => {
                  return (
                    <div
                      key={query?.id}
                      className={`${classes.queryList} ${
                        queryListActive === query?.id ? classes.itemActive : ""
                      }`}
                      onClick={() => queryListClick(query)}
                    >
                      <div className={classes.queryList__inner}>
                        <div className={classes.innerCheckboxCreatedName}>
                          <FormProvider {...methods}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                              <Input
                                label={""}
                                type="checkbox"
                                name={`selectOneByOne${query?.id}`}
                                width="1.5"
                                id={query?.id}
                                height="1.5"
                                labelColor="light"
                                direction="row-reverse"
                                onClick={(e) => selectCheckbox(query, e)}
                                checked={isCheck.includes(query?.id)}
                              />
                            </form>
                          </FormProvider>
                          <div>
                            {query?.CreatedName}
                            <div
                              className={classes.queryTxt}
                              style={{
                                color: query?.IsReadByAdmin
                                  ? "#b6b6b6"
                                  : "#000",
                                fontWeight: query?.IsReadByAdmin
                                  ? "initial"
                                  : "700",
                              }}
                            >
                              {query?.Text}
                            </div>
                          </div>
                        </div>
                        <div className={classes.queryList__dateTime}>
                          <span>
                            {query?.ModifiedTime?.match(/([^T]+)/)[0]
                              .split("-")
                              .reverse()
                              .join("/")}
                          </span>
                          <span>
                            {convertTime(
                              `${query?.ModifiedTime?.match(/\d\d:\d\d/)}`
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </InfiniteScrollComponent>
            </div>
          </div>

          <div className={classes.rightPanel}>
            <div className={classes.rightPanel__inner}>
              <h4>Conversation Window :</h4>
              <div className={classes.innerTopHeader}>
                <div className={classes.createdName}>
                  {/* {queryreplies?.CreatedName} */}
                  {queryreplies?.Text}
                  {queryreplies?.QueryAttachmentUrl !== null && (
                    <div
                      className={classes.viewAttachement}
                      onClick={() =>
                        handleViewAttachemnt(queryreplies?.QueryAttachmentUrl)
                      }
                    >
                      <a href="#">
                        <FormattedMessage id="VIEWIMAGE_TEXT" />
                      </a>
                    </div>
                  )}
                </div>
                <div
                  className={classes.viewDetails}
                  onClick={() => {
                    localStorage.setItem(
                      "shotclassTypeFrom",
                      "publishedByOthers"
                    );
                    window.open(
                      `${createShotclasses.viewpath(tenantName)}/${
                        queryreplies?.RelatedId
                      }`,
                      "_blank"
                    );
                  }}
                >
                  <FormattedMessage id="VIEW_DETAILS_TEXT" />
                </div>
              </div>

              <div className={classes.chatWindow}>
                <div className={classes.innerMessage}>
                  {queryreplies?.Replies?.map((replies) => {
                    return (
                      <>
                        <div
                          className={`${classes.userChatMain} ${
                            replies?.CreatedBy === myProfile?.LoginId
                              ? ""
                              : classes.withAvtar
                          }`}
                        >
                          {replies.CreatedBy !== myProfile?.LoginId && (
                            <div className={classes.description_meta_info}>
                              <div className={classes.avtar}>
                                <img
                                  src={
                                    replies?.CommentedByPhotoUrl
                                      ? replies?.CommentedByPhotoUrl
                                      : profileImg
                                  }
                                  className={classes.avtar_image}
                                  alt="PROFILE_IMAGE"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = profileImg;
                                  }}
                                />
                              </div>
                              <div className={classes.avtar_name}>
                                {/* {replies?.CreatedBy} */}
                                {queryreplies?.CreatedName}
                              </div>
                            </div>
                          )}
                          <div key={replies.id} className={classes.message}>
                            {replies?.Text}
                            <div className={classes.createdName}>
                              <div className={classes.nameTime}>
                                <span className={classes.createName}>
                                  {replies?.CreatedName}
                                </span>
                                <span className={classes.createDateTime}>
                                  <span>
                                    {new Date(replies.CreatedTime)
                                      .toISOString()
                                      .slice(0, 10)
                                      .split("-")
                                      .reverse()
                                      .join("/")}
                                  </span>
                                  <span>
                                    {new Date(replies.CreatedTime)
                                      .toISOString()
                                      .substring(11, 19)}
                                  </span>
                                  <span>
                                    {convertTimeAmPm(
                                      `${replies?.CreatedTime?.match(
                                        /\d\d:\d\d/
                                      )}`
                                    )}
                                  </span>
                                </span>
                              </div>

                              {replies.ReplyAttachmentUrl !== null && (
                                <div
                                  className={classes.viewAttachement}
                                  onClick={() =>
                                    handleViewAttachemnt(
                                      replies?.ReplyAttachmentUrl
                                    )
                                  }
                                >
                                  <a href="#">
                                    <FormattedMessage id="VIEWIMAGE_TEXT" />
                                  </a>
                                </div>
                              )}
                            </div>
                            {/* {commentPost?.commentPost} */}
                          </div>
                        </div>
                      </>
                    );
                  })}
                  {queryreplies?.Replies === null && (
                    <div className={classes.chatNoMessage}>No Record Found</div>
                  )}
                </div>
              </div>

              <div className={classes.chatInputEditor}>
                <div className={classes.chatEditorField}>
                  <div className={classes.inputBox}>
                    <input
                      label={""}
                      name="commentInput"
                      placeholder="Type your comment here"
                      width="100%"
                      height="0"
                      gap="0"
                      onChange={handleComment}
                      value={commentPost}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                  <div className={classes.chatBtn}>
                    <Button
                      label={<FormattedMessage id="CREATE_SUBMIT_TEXT" />}
                      type="submit"
                      borderRadius="2.4"
                      width="15"
                      dark
                      onClick={handleCommentBtn}
                      disabled={!commentPost.trim()}
                      loading={btnLoader}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={classes.noQueryFound}>No Queries found</div>
        </>
      )}
    </div>
  );
};

export default Course;
